import { MoreOutlined } from '@ant-design/icons';
import { Menu, message, Popover } from 'antd';
import { NavBar } from 'antd-mobile';
import { useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { handleBack } from 'helpers/handleBack';
import styled from 'styled-components';
import useTranslations from '../../hooks/useTranslations';

const NavbarStyled = styled(NavBar)`
    background-color: var(--primary-color);
    height: calc(58px + env(safe-area-inset-top));
    color: white;
    position: fixed;
    top: 0;
    z-index: 999;
    width: 100vw;
    max-width: 430px;
    padding-top: env(safe-area-inset-top);
    touch-action: none;
    overflow: hidden;
`;

const PopoverStyled = styled(Popover)`
    .ant-popover-inner-content {
        padding: 0px 16px;
        z-index: 9999999999;
    }
`;

const MenuStyled = styled(Menu)`
    width: 100px;
    &.ant-menu-vertical {
        border-right: unset;
    }

    .ant-menu-item {
        height: 30px;
        padding: 0px;
        display: flex;
        align-items: center;
    }
`;

export function ExtraButton() {
    const { t } = useTranslations();

    const [openCopyLink, setOpenCopyLink] = useState(false);

    const textCopy = t('CopyLink', 'Copy Link');
    const textCopiedSuccess = t('CopiedSuccessfully', 'Copied to clipboard!');

    const copyTextToClipboard = async (text) => {
        try {
            await navigator.clipboard.writeText(text);
            message.success(textCopiedSuccess);
        } catch (err) {
            console.error('Failed to copy text: ', err);
        }
    };

    return (
        <div style={{ fontSize: 24 }}>
            <PopoverStyled
                getPopupContainer={(e) => e.closest('.ant-popover-open')}
                trigger="click"
                open={openCopyLink}
                onOpenChange={() => setOpenCopyLink(true)}
                content={
                    <MenuStyled>
                        <Menu.Item
                            onClick={() => {
                                copyTextToClipboard(window.location.href);
                                setOpenCopyLink(false);
                            }}
                            key="1"
                        >
                            {textCopy}
                        </Menu.Item>
                    </MenuStyled>
                }
            >
                <MoreOutlined />
            </PopoverStyled>
        </div>
    );
}

/**
 * @param {object} props
 * @param {boolean} props.showBack
 * @param {import('react').ReactNode} props.extraButton
 * @param {string} props.titleHeader
 * @returns
 */
function PageHeader({ showBack = true, extraButton, titleHeader, onBack }) {
    const { pathname } = useLocation();
    const navigate = useNavigate();

    const title = useMemo(() => {
        const isTherapistMenu = pathname.startsWith('/therapist/');
        const [, pathGuest] = pathname.split('/');
        const currentPath = isTherapistMenu ? pathname.split('/')?.[2] : pathGuest;
        return currentPath
            ?.split('-')
            .map((item) => item.charAt(0).toUpperCase() + item.slice(1))
            .join(' ');
    }, [pathname]);

    return (
        <NavbarStyled
            onBack={() => handleBack(navigate, onBack)}
            right={extraButton || <ExtraButton />}
            {...(!showBack && {
                back: null,
            })}
        >
            {titleHeader || title}
        </NavbarStyled>
    );
}

export default PageHeader;
